export const MANAGER_SUMMARY_REPORT_GO_BUTTON_API = 'MANAGER_SUMMARY_REPORT_GO_BUTTON_API'
export const MANAGER_SUMMARY_REPORT_GO_BUTTON_API_SUCCESS = 'MANAGER_SUMMARY_REPORT_GO_BUTTON_API_SUCCESS'


export const MANAGER_SUMMARY_REPORT_API_ERROR_ACTION = 'MANAGER_SUMMARY_REPORT_API_ERROR_ACTION'